<div class="pagecontent">
    <h1 class="header1">Trip Location Information</h1>
    <h2 class="header2">
        <span>What are the travel details of your trip?</span>
    </h2>
    <div class="trip-location-content" formGroupName="tripRequest">
        <div class="trip-location-adjusted-width-row">
            <div class="form-field control-width">
                <mat-label for="appointmentTypeId">Type Of MA Appointment <span class="star">*</span></mat-label> 
                <mat-form-field>                              
                    <mat-select formControlName="appointmentTypeId" placeholder="Select MA Appointment" (selectionChange)="onAppointmentTypeChange($event)" 
                        [errorStateMatcher]="matcher" [readonlySelect]="tripRequest.get('isAcceptedPreTrip')?.value">
                        @for (appType of appointmentTypesList$ | async; track appType.id;) {
                            <mat-option [value]="appType.id">{{ appType.appointmentTypeName }}</mat-option>
                        }
                    </mat-select>
                    @if (hasError('appointmentTypeId', 'required')) {
                        <mat-error>This field is required.</mat-error>
                    }
                </mat-form-field>
            </div>
            @if(showAppointmentType) {
                <div class="form-field control-width">
                    <label for="appointmentType">MA Appointment Type <span class="star">*</span></label>
                    <mat-form-field appearance="outline">
                        @if(!tripRequest.get('isAcceptedPreTrip')?.value){
                            <input formControlName="appointmentType" matInput placeholder="Enter Appointment Type" [errorStateMatcher]="matcher" />
                        }
                        @else {
                            <input formControlName="appointmentType" matInput placeholder="Enter Appointment Type" [errorStateMatcher]="matcher" 
                            readonly class="no-global" />
                        }
                        
                        @if (hasError('appointmentType', 'required')) {
                            <mat-error>This field is required.</mat-error>
                        }
                    </mat-form-field>
                </div>
            }

        </div>
        @for (address of tripAddressFr.controls; track address; let i = $index) {
            <div formArrayName="tripAddresses">   
                <div  [formGroupName]="i" >
                    @if (address.get('locationMannualEntry')?.value === true) {
                        <div class="trip-location-row">                                 
                            <div class="form-field">
                                <mat-label for="addressCategoryId">Address Category <span class="star">*</span> </mat-label> 
                                <mat-form-field>
                                    <mat-select formControlName="addressCategoryId" placeholder="Select Category" [errorStateMatcher]="matcher" [readonlySelect]="tripRequest.get('isAcceptedPreTrip')?.value">
                                    @for (category of addressCategoryList$ | async; track category.categoryId) {
                                        <mat-option [value]="category.categoryId.toString()">{{ category.categoryName }}</mat-option>
                                    }
                                    </mat-select>
                                    @if (hasError(`tripAddresses.${i}.addressCategoryId`, 'required')) {
                                        <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            @if(IsOtherCategory(address.get('addressCategoryId')?.value)) {
                                <div class="form-field">
                                    <label [for]="'otherCategoryType' + i">Other Category Type <span class="star">*</span></label>
                                    <mat-form-field appearance="outline">
                                        @if(!tripRequest.get('isAcceptedPreTrip')?.value){
                                            <input [id]= "'otherCategoryType' + i" formControlName="otherCategoryType" matInput placeholder="Enter otherCategoryType" [errorStateMatcher]="matcher" />
                                        }
                                        @else {
                                            <input [id]= "'otherCategoryType' + i" formControlName="otherCategoryType" matInput placeholder="Enter otherCategoryType" 
                                            [errorStateMatcher]="matcher" readonly  class="no-global"/>
                                        }
                                        @if (hasError(`tripAddresses.${i}.otherCategoryType`, 'required')) {
                                            <mat-error>This field is required.</mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                            }
                            <div class="form-field">
                                <label [for]="'providerOrNickName' + i">Provider Name/ Nickname <span class="star">*</span></label>
                                <mat-form-field appearance="outline">
                                    @if(!tripRequest.get('isAcceptedPreTrip')?.value){
                                        <input [id]= "'providerOrNickName' + i" formControlName="providerOrNickName" matInput placeholder="Enter Provider/ Nickname" [errorStateMatcher]="matcher" />
                                    }
                                    @else {
                                        <input [id]= "'providerOrNickName' + i" formControlName="providerOrNickName" matInput placeholder="Enter Provider/ Nickname" 
                                        [errorStateMatcher]="matcher" readonly class="no-global" />
                                    }
                                    
                                    @if (hasError(`tripAddresses.${i}.providerOrNickName`, 'required')) {
                                        <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <div class="address-form-field">
                                <label [for]="'address' + i">{{getAddressCaption(i)}} <span class="star">*</span></label>
                                <mat-form-field appearance="outline">
                                    @if(!tripRequest.get('isAcceptedPreTrip')?.value){
                                        <input [id]="'address' + i" class="address-width" formControlName="address" matInput placeholder="Search Address" 
                                        [errorStateMatcher]="matcher" [matAutocomplete]="auto" (input)="onAddressEntered(i)"/>
                                    }
                                    @else {
                                        <input [id]="'address' + i" class="address-width" formControlName="address" matInput placeholder="Search Address" 
                                        [errorStateMatcher]="matcher" readonly class="no-global"/>
                                    }
                                    <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption (optionSelected)="onAddressSelected($event, i)">
                                        @for (ads of filteredAddress$[i] | async; track $index) {
                                        <mat-option [value]="ads">
                                            {{ ads }}
                                        </mat-option>
                                        }
                                    </mat-autocomplete>
                                    @if (hasError(`tripAddresses.${i}.address`, 'required')) {
                                        <mat-error>This field is required.</mat-error>
                                    }
                                    @if (hasError(`tripAddresses.${i}.address`, 'inValidStateCode')) {
                                        <mat-error>Invalid State.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        </div>
                        @if(!tripRequest.get('isAcceptedPreTrip')?.value) {
                            <div [ngClass]="getSubRowClass(i)">
                                @if (tripAddressFr.controls.length === i+1 && tripRequest.get('showRoundTrip')?.value === true) {
                                    <mat-checkbox [formControl]="getIsRoundTripControl()" (change)="onRoundTripChange($event)">Round Trip</mat-checkbox>                                    
                                }
                                <div class="sub-row-container">
                                    <span>Select from provider <a tabindex="0" role="button" 
                                        (click)="onEnterExistingLocation(address.get('locationMannualEntry'))" 
                                        (keydown.enter)="onEnterExistingLocation(address.get('locationMannualEntry'))"> List</a></span> 
                                    @if(i !== 0 && i !== tripAddressFr.controls.length -1 ) {
                                        <span>Remove <a tabindex="0" role="button" (click)="removeStopping(i)" 
                                            (keydown.enter)="removeStopping(i)">Stop</a></span>
                                    }
                                    <mat-checkbox formControlName="saveAddress">Save Address to Profile</mat-checkbox> 
                                </div>                              
                            </div>
                            @if (i !== 0) {
                                <div class="map-container">
                                        <span>Pick <a tabindex="0" role="button" 
                                            (click)="onSelectAddressfromMap(i)" 
                                            (keydown.enter)="onSelectAddressfromMap(i)">Address</a> from map</span>                            
                                </div>
                            }
                        }
                    }
                    @else {
                        <div class="trip-location-row"> 
                            <div class="form-field">
                                <mat-label for="addressCategoryId">Address Category <span class="star">*</span></mat-label>
                                <mat-form-field>
                                    <mat-select  placeholder="Select Category" formControlName="addressCategoryId" 
                                        (selectionChange)="onAddressCategoryChange($event, i)" [errorStateMatcher]="matcher" 
                                        [readonlySelect]="tripRequest.get('isAcceptedPreTrip')?.value">
                                        @for (category of recipientaddressCategories$ | async; track category.categoryId) {
                                            <mat-option [value]="category.categoryId">{{ category.categoryName }}</mat-option>
                                        }
                                    </mat-select>
                                    @if (hasError(`tripAddresses.${i}.addressCategoryId`, 'required')) {
                                        <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>
                            </div>                                
                            <div class="form-field">
                                <mat-label for="selectedAddress">Provider Name/ Nickname</mat-label>
                                <mat-form-field>
                                    <mat-select placeholder="Select Provider Address" formControlName="selectedAddress" 
                                                (selectionChange)="onProviderAddressChange($event, i)" [readonlySelect]="tripRequest.get('isAcceptedPreTrip')?.value">
                                    @for (provider of providerAddress$[i] | async; track provider.providerWithAddress; let isLast = $last) {
                                        <mat-option [value]="provider.address">
                                            {{ provider.providerWithAddress }} <br/>
                                            @if(!isLast) {
                                                <hr style="height: 2px; background-color: #adaaaa; border: none;">
                                            }
                                        </mat-option>
                                    }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="address-form-field">
                                <label [for]="'address' + i">{{getAddressCaption(i)}} <span class="star">*</span></label>
                                <mat-form-field appearance="outline">
                                    @if(!tripRequest.get('isAcceptedPreTrip')?.value) {
                                        <input [id]= "'address' + i" formControlName="address" matInput placeholder="Search Address" [errorStateMatcher]="matcher"
                                        [matAutocomplete]="auto" (input)="onAddressEntered(i)" [readonly]="address.get('addressCategoryId')?.value === '6'" />
                                    }
                                    @else {
                                        <input [id]= "'address' + i" formControlName="address" matInput placeholder="Search Address" [errorStateMatcher]="matcher"
                                         readonly class="no-global" />
                                    }
                                    <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption (optionSelected)="onAddressSelected($event, i)" >
                                        @for (ads of filteredAddress$[i] | async; track $index;) {
                                            <mat-option [value]="ads">{{ ads }}</mat-option>
                                        }
                                    </mat-autocomplete>
                                    @if (hasError(`tripAddresses.${i}.address`, 'required')) {
                                        <mat-error>This field is required.</mat-error>
                                    }
                                    @if (hasError(`tripAddresses.${i}.address`, 'inValidStateCode')) {
                                        <mat-error>Invalid State.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        </div>
                         @if(!tripRequest.get('isAcceptedPreTrip')?.value) {
                            <div [ngClass]="getSubRowClass(i)">
                                @if (tripAddressFr.controls.length === i+1 && tripRequest.get('showRoundTrip')?.value === true ) {
                                    <mat-checkbox [formControl]="getIsRoundTripControl()" (change)="onRoundTripChange($event)">Round Trip</mat-checkbox>                                   
                                }  
                                <div class="sub-row-container">  
                                    @if(i !== 0 && i !== tripAddressFr.controls.length -1 ) {
                                        <span>Remove <a tabindex="0" role="button" (click)="removeStopping(i)" (keydown.enter)="removeStopping(i)">Stop</a></span>
                                    }                                 
                                    <span>Don't find an address? <a tabindex="0" role="button" (click)="onEnterLocationManual(address.get('locationMannualEntry'))" (keydown.enter)="onEnterLocationManual(address.get('locationMannualEntry'))">Enter location information</a></span>
                                    @if (address.get('addressCategoryId')?.value !== homeAddressCategory) {
                                        <mat-checkbox formControlName="saveAddress">Save Address to Profile</mat-checkbox> 
                                    }                                                                                                 
                                </div>
                            </div>
                            @if (i !== 0) {
                                <div class="map-container">
                                    <span>Pick <a tabindex="0" role="button" (click)="onSelectAddressfromMap(i)" (keydown.enter)="onSelectAddressfromMap(i)">Address</a> from map</span>
                                </div>
                            }
                        }
                    }
                </div>
            </div>
        } 
        @if(!tripRequest.get('isAcceptedPreTrip')?.value) {
            <div class="add-stop-row">
                @if (tripRequest.get('showAdditionalStop')?.value === true) {
                    <button type="button" matInput  mat-button (click)="addAdditionalStop()" >Add Additional Stop</button>
                }

            </div> 
        }
    </div>
</div>
        
